// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___j6nsM","rightPanel":"rightPanel___nmree","modal":"modal___YpnP7"};